export const NAMESPACE = 'USERS/';
export const DOWNLOAD = `${NAMESPACE}DOWNLOAD`;
export const FETCH = `${NAMESPACE}FETCH`;
export const SET_PARAMS = `${NAMESPACE}SET_PARAMS`;
export const RESET = `${NAMESPACE}RESET`;
